<template>
    <div class="about-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div class="header-bg" style="background-image: url('https://picsum.photos/id/1071/1920/400');"></div>
            <div class="header-content">
                <h1>关于我们</h1>
                <p>四川庚源电力科技有限公司 - 新能源二次设备安装及调试专家</p>
            </div>
        </div>

        <!-- 公司简介 -->
        <section class="company-intro">
            <div class="container">
                <div class="intro-content">
                    <div class="intro-text">
                        <h2>公司简介</h2>
                        <p>{{ companyInfo.introduction}}</p>
                        <p>自成立以来，公司凭借专业的技术团队和丰富的行业经验，与南瑞继保、长园深瑞、国能日新、北京四方等知名厂家建立了密切的合作关系，参与了多个大型新能源项目的建设与调试工作，项目实施与执行经验丰富</p>
                    </div>
                    <div class="intro-img">
                        <img src="https://picsum.photos/id/1048/600/400" alt="公司办公环境">
                    </div>
                </div>
            </div>
        </section>

        <!-- 发展历程 -->
        <section class="development-history">
            <div class="container">
                <h2>发展历程</h2>
                <div class="timeline">
                    <div class="timeline-item">
                        <div class="timeline-date">2019年</div>
                        <div class="timeline-content">
                            <h3>公司成立</h3>
                            <p>四川庚源电力科技有限公司2019年正式成立，专注于新能源二次设备安装及调试服务</p>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="timeline-date">2020年</div>
                        <div class="timeline-content">
                            <h3>拓展业务</h3>
                            <p>与南瑞继保建立合作关系，承接多个新能源发电项目的设备安装及调试工作</p>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="timeline-date">2022年</div>
                        <div class="timeline-content">
                            <h3>规模扩大</h3>
                            <p>技术团队扩展至30人，年完成项目超过20个，业务覆盖西南地区</p>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="timeline-date">2023年</div>
                        <div class="timeline-content">
                            <h3>战略合作</h3>
                            <p>与中国华能集团、国电投、中电、华电等发电集团;南瑞继保、国能日新、长园深瑞等设备厂商达成战略合作伙伴关系，业务范围扩展至全国</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 企业文化 -->
        <section class="corporate-culture">
            <div class="container">
                <h2>企业文化</h2>
                <div class="culture-grid">
                    <div class="culture-item">
                        <div class="culture-icon">
                            <i class="fa fa-lightbulb-o"></i>
                        </div>
                        <h3>企业使命</h3>
                        <p>为新能源行业提供专业、高效的技术服务，推动清洁能源的发展与应用</p>
                    </div>
                    <div class="culture-item">
                        <div class="culture-icon">
                            <i class="fa fa-eye"></i>
                        </div>
                        <h3>企业愿景</h3>
                        <p>成为国内领先的新能源设备及技术服务提供商</p>
                    </div>
                    <div class="culture-item">
                        <div class="culture-icon">
                            <i class="fa fa-heart"></i>
                        </div>
                        <h3>核心价值观</h3>
                        <p>专业、诚信、创新、卓越，以技术为根本，以服务为导向</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 团队介绍 -->
        <!--
        <section class="team-intro">
            <div class="container">
                <h2>专业团队</h2>
                <p class="section-desc">公司拥有一支经验丰富、技术精湛的专业团队，核心成员均具有10年以上新能源行业经验</p>
                <div class="team-grid">
                    <div class="team-member">
                        <div class="member-img">
                            <img src="https://picsum.photos/id/1012/300/300" alt="团队成员">
                        </div>
                        <h3>张工程师</h3>
                        <p class="member-title">技术总监</p>
                        <p>15年新能源行业经验，曾参与多个国家级大型风电、光伏项目的调试工作</p>
                    </div>
                    <div class="team-member">
                        <div class="member-img">
                            <img src="https://picsum.photos/id/1025/300/300" alt="团队成员">
                        </div>
                        <h3>李工程师</h3>
                        <p class="member-title">项目经理</p>
                        <p>12年项目管理经验，擅长协调各方资源，确保项目高效推进和顺利交付</p>
                    </div>
                    <div class="team-member">
                        <div class="member-img">
                            <img src="https://picsum.photos/id/1027/300/300" alt="团队成员">
                        </div>
                        <h3>王工程师</h3>
                        <p class="member-title">技术骨干</p>
                        <p>10年二次设备调试经验，精通各类保护装置和自动化系统的调试技术</p>
                    </div>
                </div>
            </div>
        </section>
        -->
    </div>
</template>

<script>
import { companyApi } from '@/api'

export default {
    name: 'AboutPage',
    data() {
        return {
            companyInfo: {}
        }
    },
    mounted() {
        this.getCompanyInfo()
    },
    methods: {
        getCompanyInfo() {
            companyApi.getCompanyInfo().then(res => {
                if (res) {
                    this.companyInfo = res.data
                }
            }).catch(err => {
                console.error('获取公司信息失败:', err)
            })
        }
    }
}
</script>

<style scoped>
.page-header {
    position: relative;
    height: 400px;
    overflow: hidden;
}

.header-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: brightness(0.6);
}

.header-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
}

.header-content h1 {
    font-size: 3rem;
    margin-bottom: 15px;
}

.header-content p {
    font-size: 1.2rem;
}

section {
    padding: 80px 0;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

h2 {
    font-size: 2rem;
    color: #2c3e50;
    margin-bottom: 40px;
    text-align: center;
    position: relative;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
    padding-bottom: 10px;
}

h2::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: #165DFF;
}

/* 公司简介样式 */
.company-intro {
    background-color: #f9f9f9;
}

.intro-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: center;
}

.intro-text p {
    font-size: 1rem;
    line-height: 1.8;
    color: #555;
    margin-bottom: 20px;
}

.intro-img img {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* 发展历程样式 */
.development-history {
    background-color: #fff;
}

.timeline {
    position: relative;
    max-width: 1000px;
    margin: 0 auto;
}

.timeline::after {
    content: '';
    position: absolute;
    width: 6px;
    background-color: #f1f1f1;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
}

.timeline-item {
    padding: 10px 40px;
    position: relative;
    width: 50%;
    box-sizing: border-box;
}

.timeline-item:nth-child(odd) {
    left: 0;
}

.timeline-item:nth-child(even) {
    left: 50%;
}

.timeline-item::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: white;
    border: 4px solid #165DFF;
    top: 15px;
    border-radius: 50%;
    z-index: 1;
}

.timeline-item:nth-child(odd)::after {
    right: -13px;
}

.timeline-item:nth-child(even)::after {
    left: -13px;
}

.timeline-date {
    font-weight: bold;
    color: #165DFF;
    margin-bottom: 10px;
}

.timeline-content {
    padding: 20px;
    background-color: white;
    position: relative;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.timeline-content h3 {
    margin-bottom: 10px;
    color: #2c3e50;
}

.timeline-content p {
    color: #7f8c8d;
    line-height: 1.6;
}

/* 企业文化样式 */
.corporate-culture {
    background-color: #f9f9f9;
}

.culture-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
}

.culture-item {
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.culture-icon {
    width: 70px;
    height: 70px;
    background-color: #f0f5ff;
    color: #165DFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    font-size: 1.8rem;
}

.culture-item h3 {
    font-size: 1.3rem;
    color: #2c3e50;
    margin-bottom: 15px;
}

.culture-item p {
    color: #7f8c8d;
    line-height: 1.6;
}

/* 团队介绍样式 */
.team-intro {
    background-color: #fff;
}

.section-desc {
    text-align: center;
    color: #7f8c8d;
    max-width: 700px;
    margin: 0 auto 50px;
    line-height: 1.6;
}

.team-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
}

.team-member {
    text-align: center;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    transition: transform 0.3s;
}

.team-member:hover {
    transform: translateY(-10px);
}

.member-img {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto 20px;
    border: 5px solid #fff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.member-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.team-member h3 {
    font-size: 1.2rem;
    color: #2c3e50;
    margin-bottom: 5px;
}

.member-title {
    color: #165DFF;
    margin-bottom: 15px;
    font-size: 0.9rem;
}

.team-member p {
    color: #7f8c8d;
    line-height: 1.6;
}

/* 响应式样式 */
@media (max-width: 992px) {
    .intro-content {
        grid-template-columns: 1fr;
    }

    .timeline::after {
        left: 31px;
    }

    .timeline-item {
        width: 100%;
        padding-left: 70px;
        padding-right: 25px;
    }

    .timeline-item:nth-child(even) {
        left: 0;
    }

    .timeline-item:nth-child(odd)::after,
    .timeline-item:nth-child(even)::after {
        left: 18px;
    }
}

@media (max-width: 768px) {
    .header-content h1 {
        font-size: 2.2rem;
    }

    h2 {
        font-size: 1.8rem;
    }
}

@media (max-width: 576px) {
    .page-header {
        height: 300px;
    }

    .header-content h1 {
        font-size: 1.8rem;
    }

    .header-content p {
        font-size: 1rem;
    }

    section {
        padding: 50px 0;
    }
}
</style>
